import TheListResource from "Components/Common/Component/resource/TheListResource";
import { Fragment, useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { Button, Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import MoonLoader from "react-spinners/MoonLoader";
import axiosInstance from "hook/axiosInstance";
import { useCrudApi } from "hook/useCrudApi";
import { HoSoCaNhan } from "models/ho-so-ca-nhan";
const PhanQuyenPage = () => {
  const [dataSource, setDataSource] = useState<any>([]);
  const [phanQuyenType, setPhanQuyenType] = useState<"account" | "group">(
    "account"
  );
  const [selectedAccount, setSelectedAccount] = useState<any>(null);
  const [selectedGroup, setSelectedGroup] = useState<any>(null);
  const [roles, setRoles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const permissionIds = useMemo(() => {
    return dataSource.filter((x) => x.enabled).map((x) => x.id);
  }, [dataSource]);

  const allPermissionName = "all";

  const { usePaginationQuery, useSearch } =
    useCrudApi<HoSoCaNhan>("HoSoCaNhan");

  const usePaginationReturn = usePaginationQuery(1, 9999);
  const { page, pageSize } = usePaginationReturn;

  const [searchKeyword, setSearchKeyword] = useState("");
  const { data, refetch } = useSearch(
    searchKeyword,
    { page, pageSize },
    {
      enabled: true,
    }
  );

  const accountOptions = data?.data.map((user) => ({
    value: user.id,
    label: user.hoTen,
  }));


  const resetPermission = () => {
    setDataSource(dataSource.map((x) => ({ ...x, enabled: false })));
  };

  useEffect(() => {
    getListPhanQuyen();
  }, []);

  useEffect(() => {
    resetPermission();
  }, [phanQuyenType]);

  useEffect(() => {
    if (selectedAccount) {
      handlePhanQuyen();
    }
  }, [selectedAccount]);

  const getListPhanQuyen = async () => {
    const res = await axiosInstance.get("master/permission");
    const items = res.data.data.map(({ displayName, id }) => ({
      name: displayName,
      id,
    }));
    setDataSource(items);
  };

  const handlePhanQuyen = async () => {
    const res = await axiosInstance.get(
      `user/${selectedAccount.value}/permission`
    );
    const ids = res.data.data.map((x) => x.permissionId);
    setDataSource((prev) =>
      prev.map((x) => ({ ...x, enabled: ids.includes(x.id) }))
    );
  };

  const handlePhanQuyenGroup = async () => {
    try {
      setLoading(true);
      await axiosInstance.put(`user/permission/update-by-role`, {
        roleId: selectedGroup.value,
        permissionIds: permissionIds,
      });
      toast.success("Cập nhật quyền thành công");
    } catch (error) {
      toast.error(error?.response?.data?.message || " Có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePermission = (row) => {
    setDataSource((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, enabled: !item.enabled } : item
      )
    );
  };

  const tableColumns = [
    {
      name: "Trang",
      selector: (row) => row.name,
    },
    {
      name: "Có quyền",
      selector: (row) => (
        <Checkbox
          id={row.id}
          checked={row.enabled}
          onChange={() => handleUpdatePermission(row)}
          disabled={!selectedAccount && !selectedGroup}
        />
      ),
    },
  ];

  const handleUpdatePermissions = async () => {
    if (phanQuyenType === "account") {
      handlePhanQuyenUser();
    } else {
      handlePhanQuyenGroup();
    }
  };

  const handlePhanQuyenUser = async () => {
    try {
      setLoading(true);
      await axiosInstance.put(`user/permission`, {
        permissionIds: permissionIds,
        userId: selectedAccount.value,
      });
      toast.success("Cập nhật quyền thành công");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  const Checkbox = (props) => {
    const { id } = props;
    return (
      <div className="checkbox checkbox-primary ">
        <Input
          className="form-check-input"
          id={id}
          type="checkbox"
          checked={props.checked}
          onChange={props.onChange}
          disabled={props.disabled}
        />
        <Label className="form-label mt-0 mb-3 ml-2" htmlFor={id}></Label>
      </div>
    );
  };

  const FiltersComponent = () => (
    <div className="mb-4">
      <div className="d-flex align-items-center gap-3 text-white">
        <div>
          <label style={{ marginRight: 16 }}>
            <input
              type="radio"
              value="account"
              checked={phanQuyenType === "account"}
              onChange={(e) => setPhanQuyenType("account")}
              style={{ marginRight: 8 }}
            />
            Phân quyền tài khoản
          </label>
          <label>
            <input
              type="radio"
              value="group"
              checked={phanQuyenType === "group"}
              onChange={(e) => setPhanQuyenType("group")}
              style={{ marginRight: 8 }}
            />
            Phân quyền nhóm tài khoản
          </label>
        </div>

        <div style={{ minWidth: 300 }}>
          {phanQuyenType === "account" && (
            <Select
              options={accountOptions}
              value={selectedAccount}
              onChange={setSelectedAccount}
              placeholder="Chọn tài khoản"
              className="basic-multi-select"
              classNamePrefix="select"
            />
          )}

          {phanQuyenType === "group" && (
            <Select
              options={roles}
              value={selectedGroup}
              onChange={setSelectedGroup}
              placeholder="Chọn nhóm tài khoản"
              className="basic-select"
              classNamePrefix="select"
            />
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <TheListResource
        showCreate={false}
        title="Phân quyền"
        parent="Phân quyền"
        dataSource={dataSource}
        tableColumns={tableColumns as any}
        pagination={false}
        Filter={<FiltersComponent />}
        Footer={
          <div className="d-flex justify-content-end">
            <Button onClick={handleUpdatePermissions}>Cập nhật</Button>
          </div>
        }
      />
      {loading ? (
        <div className="w-screen h-screen flex items-center justify-center app-overlay">
          <MoonLoader color="#7366ff" />
        </div>
      ) : (
        <Fragment />
      )}
    </>
  );
};

export { PhanQuyenPage };
